/**
 * Utility to verify lazy loading functionality
 * This file helps track when modules are loaded and their approximate size
 */

export class LazyLoadingVerifier {
  private static loadedModules: Record<string, { timestamp: string, approximateSize: string }> = {};

  /**
   * Log when a module is loaded
   * @param moduleName Name of the module being loaded
   * @param approximateSizeKB Approximate size of the module in KB
   */
  static logModuleLoad(moduleName: string, approximateSizeKB: number): void {
    const timestamp = new Date().toISOString();
    this.loadedModules[moduleName] = {
      timestamp,
      approximateSize: `${approximateSizeKB} KB`
    };
    
    console.log(`[Lazy Loading Verifier] Module "${moduleName}" loaded at: ${timestamp}`);
    console.log(`[Lazy Loading Verifier] Current loaded modules:`, Object.keys(this.loadedModules));
  }

  /**
   * Get all loaded modules
   */
  static getLoadedModules(): Record<string, { timestamp: string, approximateSize: string }> {
    return { ...this.loadedModules };
  }

  /**
   * Check if a module has been loaded
   * @param moduleName Name of the module to check
   */
  static isModuleLoaded(moduleName: string): boolean {
    return !!this.loadedModules[moduleName];
  }
}
